var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-landing"},[_c('iframe',{style:({'height' : _vm.aboutIframeHeight}),attrs:{"src":_vm.iframeSrc,"id":"externalPageContainer","scrolling":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }